// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_5d-6";
export var headerCell = "_5d-2";
export var rowWrapper = "_5d-4";
export var stickyAggregationCell = "_5d-a";
export var stickyAggregationRow = "_5d-7";
export var stickyColumnCell = "_5d-9";
export var stickyColumnHeaderCell = "_5d-8";
export var table = "_5d-1";
export var virtualRowWrapper = "_5d-5";
export var virtualTableContainer = "_5d-0";
export var white = "_5d-3";